<template>
  <v-form ref="form" v-bind="this.$attrs">
    <v-row>
      <v-col class=" pb-0" cols="12">
        <v-textarea v-model="notes" label="Ghi chú" outlined dense rows="3"></v-textarea>
      </v-col>
    </v-row>
    <v-row>
      <v-col class="py-0 pt-4" cols="12" md="12">
        <v-checkbox class="pa-0 ma-0" v-model="isCommunist" label="Đảng viên" hide-details></v-checkbox>
      </v-col>
      <v-col class="pb-0 mb-4" cols="12" md="6">
        <date-picker
          :disabled="!isCommunist"
          :date.sync="communistJoinedDate"
          :rules="isCommunist ? [$rules.date] : []"
          label="Ngày vào Đảng"
          outlined
          dense
        />
      </v-col>
    </v-row>
  </v-form>
</template>

<script>
import get from 'lodash-es/get'
import DatePicker from '@/components/basic/picker/DateIOSPicker.vue'

export default {
  components: {
    DatePicker
  },
  props: {
    teacher: Object,
    formState: Boolean
  },
  data: () => ({
    notes: '',
    communistJoinedDate: '',
    isCommunist: false,
  }),
  computed: {},
  created() {
    this.initData()
  },
  methods: {
    initData() {
      if (this.teacher) {
        this.notes = this.teacher.notes
        this.communistJoinedDate = get(this.teacher, 'metadata.communistJoinedDate')
      }
    },
    validate() {
      return this.$refs.form.validate()
    },
    getData() {
      return {
        notes: this.notes,
        communistJoinedDate: this.communistJoinedDate
      }
    },
    reset() {
      this.$refs.form.reset()
    },
    resetValidation() {
      this.$refs.form.resetValidation()
    }
  },
  watch: {
    formState(formState) {
      if (!formState) {
        this.initData()
      }
    }
  }
}
</script>

<style scoped></style>
